<template>
  <div class="tabBar">
    <div class="rightTabs">
      <div id="tabMargin" style="height:30px;"></div>
      <div class="tabsContent">
          <ul class="tabBox clearfix">
            <!-- tabs标签 -->
            <li :title="$i18n.t('wm_lang_db1c89')">
              <span class="icon tabs_js_home"></span>
              <a href="javascript:void(0);" class="close" :title="$i18n.t('wm_lang_873178')"><i class="el-icon-circle-close"></i></a>
            </li>
            <li :title="$i18n.t('wm_lang_e366cc')">
              <span class="icon tabs_js_set"></span>
              <a href="javascript:void(0);" class="close" :title="$i18n.t('wm_lang_873178')"><i class="el-icon-circle-close"></i></a>
            </li>
            <li :title="$i18n.t('wm_lang_183abe')">
              <span class="icon tabs_js_address"></span>
              <a href="javascript:void(0);" class="close" :title="$i18n.t('wm_lang_873178')"><i class="el-icon-circle-close"></i></a>
            </li>
            <li :title="$i18n.t('wm_lang_3bc5e6')">
              <span class="icon tabs_js_email"></span>
              <a href="javascript:void(0);" class="close" :title="$i18n.t('wm_lang_873178')"><i class="el-icon-circle-close"></i></a>
            </li>
            <li class="current" :title="$i18n.t('wm_lang_cecc29')">
              <span class="icon tabs_js_write"></span>
              <a href="javascript:void(0);" class="close" :title="$i18n.t('wm_lang_873178')"><i class="el-icon-circle-close"></i></a>
            </li>
            <li title="WM"+this.$i18n.t('wm_lang_c9a507')>
              <span class="txt tabs_js_text">WM{{$t("wm_lang_html_0f87e0")}}</span>
              <a href="javascript:void(0);" class="close" :title="$i18n.t('wm_lang_873178')"><i class="el-icon-circle-close"></i></a>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msgindex: this.$i18n.t('wm_lang_ea57da')
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabBar{
  width: 80px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/sub/tabBar.vue